<template>
  <div id="container">
    <div class="full_layout" v-if="list">
    <!-- {{USDRate}} -->
      <!-- {{ passForm }}
      {{ list }} -->
      <div class="border_half p_12">
        <b>{{$t('base.CaseOutcome')}}:</b>
        <span class="text_yellow">
          <span>{{$t('base.Closeorder')}}</span> / 
          <span v-if="(list.PlanSRResultStatus == 6&& list.IsReturn == 0) || (list.PlanSRResultStatus == 9 && list.IsReturn == 0)">{{$t('base.Refund')}}</span>
          <span v-if="list.PlanSRResultStatus > 6 || ((list.PlanSRResultStatus == 9||list.PlanSRResultStatus == 6) && list.IsReturn == 1)">{{$t('base.ReturnsRefunds')}}</span>
        </span>
      </div>
      <!--  -->
      <div class="border_half py_16 px_20">
        <!-- 标题 -->
        <div class="flex items-center space-y">
          <h2 class="text_yellow flex_1 text_2xl" v-if="list.PlanSRResultStatus == 6">{{$t('base.WaitSellerRefund')}}</h2>
          <h2 class="text_yellow flex_1 text_2xl" v-if="list.PlanSRResultStatus == 7">{{$t('base.AwaitingReturnAddress')}}</h2>
          <h2 class="text_yellow flex_1 text_2xl" v-if="list.PlanSRResultStatus == 8">{{$t('base.ReturntheItem')}}</h2>
          <h2 class="text_yellow flex_1 text_2xl" v-if="list.PlanSRResultStatus == 9">{{$t('base.Refunded')}}</h2>
          <div class="flex items-center ">
            <div class="text_blue ContactSeller px_20" @click="allContact(list.SellMemberId, orderId)">
              <div>{{ $t('base.contactSeller') }}</div>
            </div>
            <div v-if="list.PlanSRResultStatus == 8">
              <el-button type="primary" class="submit" @click="submitExpress('expressFrom')">{{$t('base.ReturntheItem')}}</el-button>
            </div>
          </div>
        </div>
        <!-- 退款退货详情 -->
        <ul id="detail" class="border_half space-y">
          <li class="flex table_head">
            <div class="flex_1">{{ $t('base.item') }}</div>
            <div class="align_right w_12">{{ $t('base.Refund') }}</div>
            <div class="align_right w_12">{{ $t('base.shippingFee') }}</div>
            <div class="align_right w_12">{{ $t('base.OtherFee') }}</div>
            <div class="align_right w_12">{{ $t('base.RefundAmount') }}</div>
          </li>
          <li class="flex p_8">
            <div class="flex_1">
              <div class="flex_1 flex" v-for="(item, index) in list.OrderDetails" :key="index">
                <div class="flex_1 flex">
                  <div>
                    <el-image class="like_img" :src="item.TitImg + '?imageView2/2/w/200'" fit="contain"></el-image>
                  </div>
                  <p class="line_txt3 flex_1 px_12">{{ item.Title }}</p>
                </div>
                <div class="align_right w_12">{{ list.RealPostageMoneyUnit }} {{ item.RefundMoney }}</div>
              </div>
            </div>
            <div class="align_right w_12">{{ list.RealPostageMoneyUnit }} {{ list.RefundPostage }}</div>
            <div class="align_right w_12">{{ list.RealPostageMoneyUnit }} {{ list.ServiceAndTaxRefund }}</div>
            <div class="align_right w_12">{{ list.RealPostageMoneyUnit }} {{ list.RebackMoney }}</div>
          </li>
        </ul>
        <!-- 退款地址 -->
        <div class="space-y" v-if="list.IsReturn && list.SellMemberAddress">
          <div class="flex items-center return_title">
            <span class="text_2xl">{{$t('base.ReturnAddress')}}</span>
            <span class="text_lg text_gray" v-if="!list.SellMemberAddress">{{$t('base.Waitsellerconfirmation')}}</span>
            <span class="copy" v-if="list.SellMemberAddress" @click="CopyLink('add')">{{$t('base.copy')}}</span>
          </div>
          <div class="p_12 px_20 text_icon icon_address" v-if="list.SellMemberAddress">
            <p>
              <span class="comma">{{ passForm.StreetAddress }}</span>
              <span class="comma">{{ passForm.StreetAddress2 }}</span>
              <span class="comma">{{ passForm.City }}</span>
              <span class="comma">{{ passForm.State }}</span>
              <span class="comma">{{ passForm.ZipCode }}</span>
            </p>
            <p>
              {{ passForm.UserName }}({{ passForm.Country }}) {{ passForm.Phone }}
            </p>
          </div>
        </div>
        <!-- 快递信息 -->
        <div class="space-y" v-if="list.IsReturn && list.SellMemberAddress">
          <div class="flex items-center return_title">
            <span class="text_2xl">{{$t('base.ReturnTrackingDetails')}}</span>
            <span class="copy" v-if="list.SendExpress"  @click="CopyLink('exp')">{{$t('base.copy')}}</span>
          </div>
          <div class="p_12 px_20 text_icon icon_exp" v-if="list.SendExpress">
            <span>{{list.SendExpressName}} {{list.SendExpress}}</span>
          </div>
          <div v-if="!list.SendExpress" class="p_12 ">
            <el-form class="flex expressFrom" ref="expressFrom" :rules="expressRules" :model="expressFrom" label-position="top">
              <div class="">
                <el-form-item label="Carrier:" prop="SendExpressName">
                  <el-select class="info_ipt" v-model="expressFrom.extraName" filterable value-key="ShipperName"
                    @change="setExpress($event)" placeholder="Carrier name">
                    <el-option v-for="(item, index) in expressShipper" :key="index" :label="item.ShipperName"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="Tracking Number:" prop="SendExpress">
                  <el-input class="info_ipt" v-model="expressFrom.SendExpress"
                    placeholder="enter Tracking Number"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <!--  -->
      <div>
        <el-alert :title="$t('alert.sellerprocess')" :closable="false"
          type="info" show-icon></el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo, GoYunXin, numMulti, isNumber } from "@/api/public";
export default {
  name: 'index',
  data() {
    return {
      userInfo: '',
      list: '',
      USDRate: '',
      orderId: '',
      expressShipper: [],
      passForm: {
        Country: '',
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        State: '',
        ZipCode: '',
        Phone: '',
      },
      expressFrom: {
        extraName: '',
        SendExpress: '',
        SendExpressName: '',
        SendExpressCode: ''
      },
      expressRules:{
        SendExpressName:[
          { required: true, message: "", trigger: 'blur' }
        ],
        SendExpress:[
          { required: true, message: "", trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  created() {
    this.$store.commit('SET_HEADER_TITLE', 'My Card Hobby');
    this.userInfo = getInfo();
    this.ordersDetail()
    // this.getPlan()
  },
  methods: {
    CopyLink(value){
      let that = this
      let text=''
      if(value=='add'){
        text=`${that.passForm.StreetAddress},
        ${that.passForm.StreetAddress2},
        ${that.passForm.City},
        ${that.passForm.State},
        ${that.passForm.ZipCode},
        ${that.passForm.UserName},
        ${that.passForm.Phone}`
      }
      if(value=='exp'){
        text=`${that.list.SendExpress}`
      }
      this.$copyText(text).then(function(e) {
        that.$message({
          message: 'Copy Successfully',
          type: 'success'
        });
      }, function(e) {
        that.$message.error('Fail');
      })
    },
    /**
     * 获取订单详情
     * @description 根据路由参数中的订单ID，调用接口获取订单详细信息
     * @returns {void}
     */
    ordersDetail() {
      let that = this
      that.orderId = this.$route.params.id
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: that.orderId }
      this.$get(this.$interface.OrdersDetail, data).then(res => {
        if (res.result) {
          let result = res.data
          that.USDRate = { ExchangeRate: result.BuyerExchangeRate, RealPostageMoneyUnit: result.RealPostageMoneyUnit }
          //console.log(result)
          that.getPlan()
        } else {

        }
      })
    },
    /**
     * 获取维权结果
     * 根据订单ID获取维权结果，处理汇率设置、退货地址设置和物流信息获取
     * @async
     * @function getPlan
     * @throws {Error} 捕获并打印可能的错误
     */
    getPlan() {
      let that = this
      that.orderId = this.$route.params.id
      try {
        let data = { OrderID: that.orderId, MemberID: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
        that.$get(that.$interface.GetPlanSRResultByOrderId, data).then(res => {
          if (res.result) {
            let result = res.data
            let oldResult = that.USDRate
            that.setRate(result, oldResult)
            if (result.IsReturn) {
              that.setAddress(result)
            }
            if (result.PlanSRResultStatus == 8) {
              that.getExpressShipper()
            }
          } else {
            that.$message({
              type: 'error',
              message: res.msg
            });
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 设置汇率并计算退款金额
     * @param {Object} result - 当前结果对象，包含需要计算的金额字段
     * @param {Object} oldResult - 旧结果对象，包含汇率信息
     * @description 
     * 1. 根据汇率(oldResult.ExchangeRate)重新计算各项退款金额
     * 2. 处理OrderDetails数组中的每个项目的退款金额
     * 3. 将计算结果合并到list中
     */
    setRate(result, oldResult) {
      let that = this
      result.RefundMoney = numMulti(isNumber(result.RefundMoney), oldResult.ExchangeRate).toFixed(2)
      result.RefundPostage = numMulti(isNumber(result.RefundPostage), oldResult.ExchangeRate).toFixed(2)
      result.ServiceAndTaxRefund = numMulti(isNumber(result.ServiceAndTaxRefund), oldResult.ExchangeRate).toFixed(2)
      result.RebackMoney = numMulti(isNumber(result.RebackMoney), oldResult.ExchangeRate).toFixed(2)
      result.OrderDetails.map(item => {
        item.RefundMoney = numMulti(isNumber(item.RefundMoney), oldResult.ExchangeRate).toFixed(2)
      })
      that.list = Object.assign({}, oldResult, result)
    },
    /**
     * 设置地址信息
     * @param {Object} result - 包含地址信息的对象
     * @description 处理地址数据，将省市区、街道地址等信息拆分并赋值到表单中
     * 1. 处理省份信息（可能包含"-"分隔符）
     * 2. 处理街道地址（可能包含括号或"|"分隔符）
     * 3. 将处理后的地址信息赋值到表单对应字段
     */
    setAddress(result) {
      let that = this
      try {
        // let cityState = [result.SellMemberAddress.Provice]
        // if (result.SellMemberAddress.Provice.indexOf("-") > -1) {
        //   cityState = result.SellMemberAddress.Provice.split("-")
        // }
        if(result.SellMemberAddress){
          let address = result.SellMemberAddress.Address
          if (address.indexOf('()') > 0) {
            address = address.replace(/\(\)/g, "")
            address = [address]
          } else {
            if (address.indexOf(')') != -1) {
              address = address.replace(")", "")
              address = address.replace("(", "|")
            }
            address = address.split("|")
          }
          that.passForm.Country = result.SellMemberAddress.Nation
          that.passForm.UserName = result.SellMemberAddress.Consignee
          that.passForm.City = result.SellMemberAddress.City
          that.passForm.State = result.SellMemberAddress.Provice
          that.passForm.ZipCode = result.SellMemberAddress.ZipCode
          that.passForm.Phone = result.SellMemberAddress.Mobile
          that.passForm.StreetAddress = address[0]
          that.passForm.StreetAddress2 = address[1]
        }
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 设置快递公司信息
     * @param {Object} e - 快递公司对象
     * @param {string} e.ShipperName - 快递公司名称
     * @param {string} e.ShipperCode - 快递公司编码
     */
    setExpress(e) {
      let that = this
      this.$set(that.expressFrom, 'SendExpressName', e.ShipperName);//快递公司名称
      this.$set(that.expressFrom, 'SendExpressCode', e.ShipperCode);//快递公司编码
    },
    /**
     * 获取快递承运商列表
     * 1. 优先检查cookie和localStorage中是否已缓存快递列表
     * 2. 若无缓存则调用接口获取数据，并存入cookie和localStorage
     * 3. 若有缓存则直接使用本地数据
     * @returns {void}
     */
    getExpressShipper() {
      let that = this
      let hasExpressShipper = that.$cookie.get('Card_ExpressShipper') ? that.$cookie.get('Card_ExpressShipper') : false;
      let ExpressShipperData = window.localStorage.getItem("Card_ExpressShipper") ? JSON.parse(window.localStorage.getItem("Card_ExpressShipper")) : [];
      if (!hasExpressShipper || ExpressShipperData.length <= 0) {
        that.$get(that.$interface.GetExpressShipper, { shipperType: 1 }).then(res => {
          if (res.Result) {
            that.$cookie.set('Card_ExpressShipper', true, { Path: "/" });//是否保存过快递列表
            window.localStorage.setItem("Card_ExpressShipper", JSON.stringify(res.Data))//将快递列表保存至本地缓存
            that.expressShipper = res.Data
          }
        })
      } else {
        that.expressShipper = ExpressShipperData
      }
    },
    /**
     * 提交快递信息
     * @param {string} formName - 表单ref名称
     * @description 验证表单并提交快递信息到后端接口
     */
    submitExpress(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {

        if (valid) {
        let expressData=that.expressFrom
        delete expressData.extraName
        let orderData={
          OrderID: that.orderId, MemberID: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken
        }
        let data={...expressData,...orderData}
        that.$post(that.$interface.ModityPlanSRResultExpress,data).then(res=>{

          if(res.result){
            that.getPlan()
          }else{

          }
        })
      }
      })
    },
    // 云信
    allContact(val, oid) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val, oid, 1001)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
  }
} 
</script>

<style scoped>
.full_layout {
  margin-top: 45px;
  min-height: 500px;
}

.like_img {
  width: 88px;
  height: 88px;
}

.copy {
  cursor: pointer;
  position: relative;
  padding-left: 18px;
  color: #5F6DAE;
}

.copy::before {
  content: "";
  background: url(../../../static/images/icon/icon_copy.svg);
  width: 17px;
  height: 16px;
  position: absolute;
  left: 0;
}

.return_title span+span {
  margin-left: 12px;
}

.space-y+.space-y {
  margin-top: 12px;
}

.w_12 {
  width: 12%;
}

.p_8 {
  padding: 8px;
}

.p_12 {
  padding: 12px;
}

.py_16 {
  padding-top: 16px;
  padding-bottom: 16px
}

.px_12 {
  padding-left: 12px;
  padding-right: 12px
}

.px_20 {
  padding-left: 20px;
  padding-right: 20px
}

.align_right {
  text-align: right;
}

.border_half {
  border: 0.5px solid #e0e0e0
}

.full_layout>div+div {
  margin-top: 12px;
}

.ContactSeller {
  background: url(../../../static/images/icon/icon_chat.svg) 0 1px no-repeat;
  padding-left: 20px;
}

.comma+.comma::before {
  content: ",";
  margin-right: 3px;
}

.text_icon {
  position: relative;
}

.text_icon::before {
  content: "";
  position: absolute;
  top: 12px;
  left: 0;
}

.icon_address::before {
  width: 16px;
  height: 18px;
  background: url(../../../static/images/icon/icon_address.svg) no-repeat;
  background-size: contain;
}

.icon_exp::before {
  width: 14px;
  height: 18px;
  background: url(../../../static/images/icon/icon_car_blue.svg) 0 4px no-repeat;
  background-size: contain;
}

#detail {
  width: 100%;
}

#detail .table_head {
  background-color: #f7f7f7;
  padding: 14px 8px;
  border-bottom: 0.5px solid #e0e0e0;
}

#detail .table_head>div:first-child {
  padding-left: 100px;
}

#detail>li>div+div {
  padding-left: 12px;
}

.expressFrom>div {
  width: 256px;
}

.expressFrom>div+div {
  margin-left: 24px;
}

/deep/ .el-form-item__label {
  line-height: 1;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/caseoutcome.vue